import { SliderComponent } from '@webikon/webentor-core/_slider';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-slider').forEach((slider) => {
    // Inicializácia SliderComponent
    const sliderInstance = new SliderComponent(
      slider,
      slider.dataset.slider ? JSON.parse(slider.dataset.slider) : {},
    );
    const swiper = sliderInstance.getSwiper();
    if (!swiper) return;

    if (swiper && swiper.params.pagination) {
      swiper.params.pagination.el = slider.querySelector(
        '.js-swiper-pagination',
      );

      swiper.pagination.destroy();
      swiper.pagination.init();
      swiper.pagination.render();
      swiper.pagination.update();

      swiper.update();

      swiper.on('slideChange', () => {
        const bullets = slider.querySelectorAll('.swiper-pagination-bullet');
        bullets.forEach((b) =>
          b.classList.remove('swiper-pagination-bullet-active'),
        );

        const real = swiper.realIndex;
        if (bullets[real]) {
          bullets[real].classList.add('swiper-pagination-bullet-active');
        }
      });
    }

    // Navigačné šípky
    const nextButtons = slider.querySelectorAll('.js-swiper-next');
    const prevButtons = slider.querySelectorAll('.js-swiper-prev');

    nextButtons.forEach((btn) =>
      btn.addEventListener('click', () => swiper.slideNext()),
    );
    prevButtons.forEach((btn) =>
      btn.addEventListener('click', () => swiper.slidePrev()),
    );
  });
});
